/*
 * Article — single-post enhancements.
 *
 * Loaded only on single-post pages (gated by body class). Adds:
 *   1) Top scroll progress bar (gradient fill tracks read %).
 *   2) TOC scrollspy + collapse toggle (active state on scroll,
 *      collapsed state persists in localStorage).
 *
 * No framework. Plain DOM, IntersectionObserver where it fits.
 */

(function () {
	if ( ! document.body.classList.contains( 'single' ) ) {
		return;
	}

	initProgressBar();
	initToc();

	function initProgressBar() {
		const wrap = document.createElement( 'div' );
		wrap.className = 'article-progress';
		const bar = document.createElement( 'div' );
		bar.className = 'article-progress__bar';
		wrap.appendChild( bar );
		document.body.prepend( wrap );

		let ticking = false;
		const update = () => {
			const max = document.documentElement.scrollHeight - window.innerHeight;
			const pct = max > 0 ? ( window.scrollY / max ) * 100 : 0;
			bar.style.width = Math.min( 100, Math.max( 0, pct ) ) + '%';
			ticking = false;
		};
		window.addEventListener( 'scroll', () => {
			if ( ! ticking ) {
				requestAnimationFrame( update );
				ticking = true;
			}
		}, { passive: true } );
		update();
	}

	function initToc() {
		const toc = document.querySelector( '.article-toc' );
		if ( ! toc ) return;

		const list = toc.querySelector( '.article-toc__list' );
		const heads = Array.from(
			document.querySelectorAll( '.article-body h2' )
		).filter( ( h ) => h.textContent.trim() );

		if ( ! heads.length ) {
			toc.hidden = true;
			return;
		}

		// Auto-id any h2 without one so anchor links resolve.
		const slugify = ( s ) => s.toLowerCase()
			.replace( /[^\w\s-]/g, '' )
			.trim()
			.replace( /\s+/g, '-' )
			.slice( 0, 60 );

		heads.forEach( ( h ) => {
			if ( ! h.id ) h.id = slugify( h.textContent ) || 'section';
		} );

		// Build list.
		list.innerHTML = '';
		heads.forEach( ( h ) => {
			const li = document.createElement( 'li' );
			const a = document.createElement( 'a' );
			a.href = '#' + h.id;
			a.textContent = h.textContent;
			a.className = 'article-toc__link';
			a.dataset.target = h.id;
			li.appendChild( a );
			list.appendChild( li );
		} );

		// Collapsed state restore.
		const STORAGE = 'oddo:toc:collapsed';
		const tocToggle = toc.querySelector( '.article-toc__toggle' );
		const setCollapsed = ( on ) => {
			toc.dataset.collapsed = on ? 'true' : 'false';
			if ( tocToggle ) {
				tocToggle.setAttribute( 'aria-expanded', on ? 'false' : 'true' );
			}
			try {
				localStorage.setItem( STORAGE, on ? '1' : '0' );
			} catch ( _ ) {}
		};
		try {
			setCollapsed( localStorage.getItem( STORAGE ) === '1' );
		} catch ( _ ) {
			setCollapsed( false );
		}

		const toggleBtn = toc.querySelector( '.article-toc__toggle' );
		if ( toggleBtn ) {
			toggleBtn.addEventListener( 'click', () => {
				setCollapsed( toc.dataset.collapsed !== 'true' );
			} );
		}

		// Scrollspy: simple scroll-position check. Active = the last
		// heading whose top has crossed 140px from the top of the
		// viewport. Plain scroll listener (no IO) so there's no
		// initial-batch race where multiple headings get marked
		// active at once.
		const links = Array.from( list.querySelectorAll( '.article-toc__link' ) );
		const update = () => {
			const offset = window.scrollY + 140;
			let activeId = null;
			heads.forEach( ( h ) => {
				if ( h.offsetTop <= offset ) activeId = h.id;
			} );
			links.forEach( ( l ) => {
				// Explicit boolean — classList.toggle's second arg as
				// `undefined` flips instead of removes, which was the
				// source of the "every link active on load" bug.
				const isActive = Boolean( activeId ) && l.dataset.target === activeId;
				l.classList.toggle( 'is-active', isActive );
			} );
		};
		let ticking = false;
		window.addEventListener( 'scroll', () => {
			if ( ! ticking ) {
				requestAnimationFrame( () => {
					update();
					ticking = false;
				} );
				ticking = true;
			}
		}, { passive: true } );
		update();
	}
} )();
